import type { CanvasIconEntity, CanvasPoint, ConstructionLine, Dimension, Shape, TextEntity } from './types';
import type { BackgroundAsset, BackgroundReference, HistorySnapshot } from './stateTypes';

export const clonePoint = (point: CanvasPoint): CanvasPoint => ({ x: point.x, y: point.y });

export const cloneBackgroundReference = (
  reference: BackgroundReference | null,
): BackgroundReference | null =>
  reference
    ? {
        startLocal: clonePoint(reference.startLocal),
        endLocal: clonePoint(reference.endLocal),
        realLength: reference.realLength,
      }
    : null;

export const cloneBackgroundAsset = (asset: BackgroundAsset | null): BackgroundAsset | null =>
  asset
    ? {
        ...asset,
        center: clonePoint(asset.center),
        reference: cloneBackgroundReference(asset.reference),
      }
    : null;

export const cloneHistorySnapshot = (
  snapshot: HistorySnapshot,
  cloneShape: (shape: Shape) => Shape,
  cloneDimension: (dimension: Dimension) => Dimension,
  cloneConstructionLine: (line: ConstructionLine) => ConstructionLine,
  cloneTextEntity: (textEntity: TextEntity) => TextEntity,
  cloneIconEntity: (iconEntity: CanvasIconEntity) => CanvasIconEntity,
): HistorySnapshot => ({
  polylines: snapshot.polylines.map(cloneShape),
  dimensions: snapshot.dimensions.map(cloneDimension),
  constructionLines: (snapshot.constructionLines ?? []).map(cloneConstructionLine),
  textEntities: (snapshot.textEntities ?? []).map(cloneTextEntity),
  iconEntities: (snapshot.iconEntities ?? []).map(cloneIconEntity),
  backgroundAsset: cloneBackgroundAsset(snapshot.backgroundAsset),
  backgroundTransparency: snapshot.backgroundTransparency,
});
